import React from 'react';

function Checkbox(props) {
    const handleClick = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (props.onClick) {
            props.onClick(props.name, !props.value);
        }
    }
    const inputProps = {
        className: props.className,
        name: props.name,
        type: 'checkbox'
    }
    let className = 'check__item';
    if (props.fullWidth) {
        className += ' check__item--fullwidth';
    }
    return (
        <span className={className} onClick={handleClick}>
            {
                props.checked &&
                <input {...inputProps} defaultChecked={true} />
            }
            {
                !props.checked &&
                <input {...inputProps} />
            }
            <label className="check__name" htmlFor={props.id}>{props.display}</label>
            {props.children}
        </span>
    );
}

function Label(props) {
    let className = 'form__label';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return <span className={className}>{props.display}</span>
}

function Message(props) {
    if (!props.message || props.message.length == 0) {
        return null;
    }
    let className = 'form__inner__msg';
    if (props.success == true) {
        className += ' form__inner__msg--success';
    }
    if (props.className) {
        className += ` ${props.className}`;
    }
    return <div className={className}>{props.message}</div>
}

function withSubmission(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            let initialState = {};
            if (props.initialState) {
                initialState = { ...props.initialState };
            }
            initialState.json = JSON.stringify(initialState);
            this.state = initialState;

            this.handleChange = this.handleChange.bind(this);
            this.handleClear = this.handleClear.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.handleSubmitComplete = this.handleSubmitComplete.bind(this);
        }

        componentDidUpdate() {
            const json = JSON.stringify(this.props.initialState);
            if (this.state.json != json) {
                this.setState({
                    ...this.props.initialState,
                    json: json
                });
            }
        }

        handleChange(name, value) {
            this.setState({
                form: undefined,
                [name]: value
            });
            if (!this.props.onChange) {
                return;
            }
            const changes = this.props.onChange(name, value);
            if (!changes) {
                return;
            }
            this.setState({ ...changes });
        }

        handleClear() {
            const state = this.state;
            for (let id in state) {
                state[id] = undefined;
            }
            this.setState(state);
        }

        handleSubmit(event) {
            if (event) {
                event.preventDefault();
            }
            if (!this.props.onSubmit) {
                return;
            }
            const component = this;
            component.setState({
                form: undefined
            }, function () {
                component.props.onSubmit({ ...component.state }, component.handleSubmitComplete);
            });
        }

        handleSubmitComplete(success, message, errorObj) {
            let _message;
            if (errorObj && errorObj.responseJSON) {
                _message = errorObj.responseJSON.Message;
            }
            if (!_message) {
                _message = message;
            }
            if (success && this.props.clearOnSubmit) {
                this.handleClear();
            }
            this.setState({
                form: {
                    success,
                    message: _message
                }
            });
        }

        render() {
            return (
                <form action="#" className={this.props.className} id={this.props.id} method="POST" onSubmit={this.handleSubmit}>
                    {
                        this.state.form &&
                        <Message {...this.state.form} />
                    }
                    {
                        this.props.message &&
                        <Message message={this.props.message} />
                    }
                    <WrappedComponent
                        {...this.props}
                        state={this.state}
                        success={this.state.form && this.state.form.success == true}
                        onChange={this.handleChange}
                        onClear={this.handleClear}>
                        {this.props.children}
                    </WrappedComponent>
                </form>
            );
        }
    }
}

export {
    Checkbox,
    Label,
    Message,
    withSubmission
}